import { render } from "./redes.vue?vue&type=template&id=7febd796"
const script = {}

import "./redes.vue?vue&type=style&index=0&id=7febd796&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__